
    import has from 'lodash/has';
    import { mapState, mapActions } from 'vuex';
    import { ValidationObserver, ValidationProvider } from 'vee-validate';
    import { faPen as falPen } from '@fortawesome/pro-light-svg-icons';
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
    import { jobData } from '@/utils/jobData';
    import datalayer from '@/utils/datalayer';
    import C1FormInput from '@/C1Components/C1FormInput';
    import C1Alert from '@/C1Components/C1Alert';

    export default {
        name: 'AuthLogin',

        components: {
            ValidationObserver,
            ValidationProvider,
            C1FormInput,
            C1Alert,
            FontAwesomeIcon,
        },

        props: {
            user: {
                type: Object,
                default: () => { return {}; },
            },

            color: {
                type: String,
                default: 'blue',
            },

            hideLabel: {
                type: Boolean,
                default: false,
            },
        },

        data() {
            return {
                password: '',
                response: {
                    message_title: '',
                    message: '',
                },
                spinner: {
                    login: false,
                    forgot_password: false,
                },
                icons: {
                    falPen,
                },
            };
        },

        computed: {
            ...mapState({
                $_apiMessage: state => state.apiMessage,
                $_authOptions: state => state.auth.authOptions,
                $_job: state => state.job.job,
            }),
        },

        methods: {
            ...mapActions('auth', {
                $_authLogin: 'login',
            }),

            ...mapActions('eventTracking', {
                $_pushEvent: 'pushEvent',
            }),

            async login() {
                if (!this.user.email) {
                    this.$emit('noEmail');
                }

                const validation = await this.$refs.formLogin.validate();
                if (!validation) {
                    return false;
                }

                this.resetResponse();

                const data = {
                    email: this.user.email,
                    password: this.password,
                };
                this.$emit('beforeLogin');
                this.$_login(data);
            },

            $_login(data) {
                this.spinner.login = true;
                this.eventLoginClick();
                this.$_authLogin(data).then((response) => {
                    this.$emit('afterLogin', response);
                }).catch((error) => {
                    const errorCode = has(error, 'response.data.error') ? error.response.data.error : 'ServerErrorException';
                    this.response.message_title = 'Login failed';
                    this.response.message = this.$_apiMessage[errorCode] || this.$_apiMessage.InvalidAuthenticationException;
                    this.spinner.login = false;
                    this.$emit('loginFailed', error);
                    this.eventLoginFailed();
                });
            },

            resetResponse() {
                this.response.message_title = '';
                this.response.message = '';
            },

            loginLater() {
                this.eventLoginLaterClick();
                this.$emit('loginLater', this.user);
            },

            eventLoginFailed() {
                const data = {
                    site_position: this.$_authOptions.sitePosition,
                    site_position_label: 'recognised_email',
                    event: 'login_failed',
                    ...jobData(this.$_job),
                };
                datalayer(data);
                this.$_pushEvent(data);
            },

            eventLoginClick() {
                const data = {
                    site_position: this.$_authOptions.sitePosition,
                    site_position_label: 'recognised_email',
                    event: 'login_click',
                    ...jobData(this.$_job),
                };
                datalayer(data);
                this.$_pushEvent(data);
            },

            eventLoginLaterClick() {
                const data = {
                    site_position: this.$_authOptions.sitePosition,
                    site_position_label: 'recognised_email',
                    event: 'login_later_click',
                    ...jobData(this.$_job),
                };
                datalayer(data);
                this.$_pushEvent(data);
            },

            changeEmail() {
                this.$emit('changeEmail');
            },
        },
    };
